import React, { PropsWithChildren } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { ResourceContent } from './multi-tenant';
import { useSelector } from 'react-redux';
import { AppRootState } from '../redux';
import { AnyType } from '../interfaces';

interface SubToolbarProps extends PropsWithChildren<unknown> {
  pageTitle?: string;
  pageIcon?: React.ReactNode;
  contentKey?: string;
  pageTitleClassName?: string;
}
export const SubToolbar = ({ children, pageTitle, pageIcon, contentKey, pageTitleClassName }: SubToolbarProps) => {
  const isHeaderText = useSelector(
    (state: AppRootState) =>
      ((state.app?.entities?.resources as AnyType) ?? {})['banner-data-sample-test-info'] as AnyType
  );
  const bannerTextEnabled = useSelector(
    (state: AppRootState) => ((state.app?.entities?.features as AnyType) ?? {})['banner-sample-text']?.data?.enabled
  );
  return (
    <Container fluid className='d-flex align-items-center flex-wrap h-auto py-3'>
      <Container>
        <Row className='justify-content-between align-items-center'>
          <Col style={{ maxWidth: 'fit-content' }}>
            {bannerTextEnabled ? (
              <h6 className='text-uppercase text-black font-weight-bold text-truncate'>
                {isHeaderText?.data?.content}
              </h6>
            ) : null}
            <div
              className='d-flex align-items-center'
              style={{ fontSize: '25px', justifyContent: 'space-between', gap: '7px' }}>
              {pageIcon}
              <h4
                className={`text-uppercase text-black font-weight-bold text-truncate mb-0 ${
                  pageTitleClassName ?? ''
                }`.trim()}
                data-testid='cmx__subtoolbar-title'
                style={{ fontWeight: '700', fontSize: '24px' }}>
                {pageTitle?.length ? pageTitle : <ResourceContent contentKey={contentKey || ''} />}
              </h4>
            </div>
          </Col>
          <Col className='justify-content-end d-flex'>{children}</Col>
        </Row>
      </Container>
    </Container>
  );
};
